/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import MapImageLayer from '@arcgis/core/layers/MapImageLayer';
import {LayerSettingsProps} from './LayerSettings';
import TrafficLayerSettings from './TrafficLayerSettings';

export type TrafficLayerContainerProps = LayerSettingsProps & {
  onOpacityChange: Function,
  onToggleExpand?: Function,
  setTrafficSubLayers?: Function,
  opacity: number,
  trafficSubLayers?: string[],
  url: string;
  expandedLayer: string
};
  
/**
 * @TrafficLayerTracking2Container
 *
 * The Traffic Layer Container provides a component which allows to instantiate
 * the Traffic Layer and Map Layer Setting.
 *
 * ```typescript
 *
 *   <TrafficLayerTracking2Container url={}
 *     isEnabled={}
 *     onToggle={}
 *     onOpacityChange={}
 *     opacity={}
 *     map={} />
 *
 * ```
 */
export const TrafficLayerTracking2Container = ({
  map,
  url,
  layers,
  isEnabled,
  onOpacityChange,
  setTrafficSubLayers,
  opacity,
  trafficSubLayers,
  onToggle,
  onToggleExpand,
  expandedLayer
}: TrafficLayerContainerProps) => {
  return (
    <TrafficLayerSettings mapImageLayer={MapImageLayer as any}
      isEnabled={isEnabled}
      url={url}
      onToggle={onToggle}
      onToggleExpand={onToggleExpand}
      onOpacityChange={onOpacityChange}
      opacity={opacity}
      setTrafficSubLayers={setTrafficSubLayers}
      trafficSubLayers={trafficSubLayers}
      layers={layers}
      map={map}
      expandedLayer={expandedLayer} />
  );
};
  
export default TrafficLayerTracking2Container;
